








































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import RegistrationFormBase from './RegistrationFormBase.vue';
import CountrySelect from '@/modules/workshops-schedule/components/CountrySelect.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

@Component({
    name: 'ArtistRegistration',
    components: {
        ValidationProvider,
        ValidationObserver,
        CountrySelect,
    },
})
export default class ArtistRegistration extends RegistrationFormBase {
    public getTranslation(key: string) {
        return this.$t(key).toString();
    }

    //#region form
    public formStep = 1;
    public sexItems = [
        { value: 1, text: this.getTranslation('userForm.male') },
        { value: 2, text: this.getTranslation('userForm.female') },
    ];
    public professionItems = [
        { value: 'Teacher', text: this.getTranslation('registrationForm.teacher') },
        { value: 'DJ', text: this.getTranslation('registrationForm.dj') },
        { value: 'Photo / Video', text: this.getTranslation('registrationForm.photoVideo') },
    ];
    public advanceLevelItems = [
        { value: 1, text: this.getTranslation('registrationForm.beginner') },
        { value: 2, text: this.getTranslation('registrationForm.intermediate') },
        { value: 3, text: this.getTranslation('registrationForm.advanced') },
        { value: 4, text: this.getTranslation('registrationForm.professional') },
    ];

    public dietTypeItems = [
        { value: 1, text: this.getTranslation('registrationForm.meat') },
        { value: 2, text: this.getTranslation('registrationForm.vegetarian') },
        { value: 3, text: this.getTranslation('registrationForm.vegan') },
    ];
    public arrivalDateItems = [
        { value: 1, text: this.getTranslation('registrationForm.zwf2022Thursday') },
        { value: 2, text: this.getTranslation('registrationForm.zwf2022Friday') },
    ];
    public departureDateItems = [
        { value: 1, text: this.getTranslation('registrationForm.zwf2022Sunday') },
        { value: 2, text: this.getTranslation('registrationForm.zwf2022Monday') },
    ];
    public howLongDancingItems = [
        { value: 1, text: this.getTranslation('registrationForm.lessThen1Year') },
        { value: 2, text: this.getTranslation('registrationForm.lessThen3Year') },
        { value: 3, text: this.getTranslation('registrationForm.lessThen5Year') },
        { value: 4, text: this.getTranslation('registrationForm.moreThen5Year') },
    ];
    public howMuchDancingItems = [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
        { value: 10, text: '10' },
    ];
    public tshirtSizeItems = [
        { value: 1, text: 'S' },
        { value: 2, text: 'M' },
        { value: 3, text: 'L' },
        { value: 4, text: 'XL' },
    ];

    protected get artistTicketsToSelect() {
        const ticketTypes = this.ticketsToSelect.filter(x => x.Name.includes('Artist'));
        return ticketTypes;
    }

    public async mounted() {
        this.eventId = 10;
        await this.prepareForm();
    }

    protected getPosType(): string {
        return 'PayU';
    }

    public clear() {
        this.formHelper.clearRegistrationForm(this.form);
        this.acceptConditions = null;

        this.clearSelectedTickets();

        (this.$refs.observer as any).reset();
        this.formStep = 1;
    }

    public async submitRegistrationForm() {
        const observer = this.$refs.observer as any;
        const result = await observer.validate();
        const errors = observer.errors;
        console.log(errors);
        if (
            errors.firstName.length ||
            errors.lastName.length ||
            errors.email.length ||
            errors.phoneNumber.length ||
            errors.sex.length
        ) {
            this.formStep = 1;
        } else if (
            errors.country.length ||
            errors.city.length ||
            errors.contactMeVia.length ||
            errors.facebook.length ||
            errors.instagram.length ||
            errors.advanceLevel.length ||
            errors.profession.length ||
            errors.dietType.length ||
            errors.arrivalDate.length ||
            errors.departureDate.length ||
            errors.tshirtSize.length
        ) {
            this.formStep = 2;
        } else if (errors.selectedTicketsIds.length) {
            this.formStep = 3;
        }

        this.form.ParticipantData.SelectedTickets.Value = this.selectedTicketsIds;
    }

    public goToNextFormStep() {
        this.formStep = this.formStep + 1;
    }

    public goToPreviousFormStep() {
        if (this.formStep > 0) {
            this.formStep = this.formStep - 1;
        }
    }

    public onResourceLoading() {
        this.setLoading(true);
    }

    public onResourceLoadingFinished() {
        this.setLoading(false);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected onError(data: any) {
        console.error(data);
        this.errored = true;
        if (data.error !== undefined) {
            this.showError(data.error.message);
        } else {
            this.showError("We can't submit your form. Please try again later or contact with the administrator.");
        }
    }

    public async onRegistartionCreated(response: any) {
        let path = `${window.location.origin}${window.location.pathname}`;
        path = path.replace('//?', '?').replace('/?', '?');

        if (response.status === 'TicketChosen' || response.status === 'RegistrationPaid') {
            this.cleanUrlParameters();
            this.fetchAvaiableTicketTypes();
            this.showInfo('Your submission has been registred.');

            return;
        }

        this.setFormDetails({
            eventRegistrationId: response.eventRegistrationId,
            eventRegistrationGuid: response.eventRegistrationGuid,
        });

        if (response.unavailableTicketsIds.length > 0) {
            response.unavailableTicketsIds.forEach((x: number) => this.toogleSelectedTicket(x));
            // reload the available tickets
            await this.fetchAvaiableTicketTypes();
            this.showInfo('Some of the selected tickets are not available any more. Please select tickets again.');

            return;
        }
    }
    //#endregion form
}
